import '@vfde-brix/contact-us/dist/styles.css';
import { createContactUsComponent } from '@vfde-brix/contact-us';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-contact-us', createContactUsComponent, NO_PATTERN_BUSINESS_LOGIC);
